import React, { useEffect, useState } from "react";
import { API_BASE_URL, DELETE_SLOTS, EDIT_SLOTS } from "../services/end_points";
import { Alert, Button, Col, Input, Row, Table, Tag, Typography } from "antd";
import moment from "moment";
import axios from "axios";
import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
const EditSlots = ({ data }) => {
  const [slots, setSlots] = useState([]);
  const [editSlots, setEditSlots] = useState(false);
  const [currentSlot, setCurrentSlot] = useState(null);
  const [isDateInput, setIsDateInput] = useState(false);
  const [datesData, setDatesData] = useState({
    date: "",
    doctorId: "",
    fromTime: "",
    toTime: "",
    interval: "",
  });
  useEffect(() => {
    if (data) {
      fetchSlotsById(data);
    }
  }, [data]);
  const fetchSlotsById = async (data) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/dateTime/getDateandTime/${data}`
      );
      if (Array.isArray(response.data)) {
        setSlots(response.data);
      } else {
        console.error("Error: Expected an array of slots");
      }
    } catch (error) {
      console.error(
        "Error fetching the data:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const handleEdit = (slot) => {
    setCurrentSlot(slot);
    setDatesData({
      date: slot.date,
      doctorId: slot.doctorId,
      fromTime: slot.fromTime,
      toTime: slot.toTime,
      interval: slot.interval,
    });
    setEditSlots(true);
  };

  const handleBack = () => {
    setEditSlots(false);
    setCurrentSlot(null);
  };

  const handleFocus = () => setIsDateInput(true);
  const handleBlur = (e) => {
    if (!e.target.value) setIsDateInput(false);
  };

  // const handleFormChange = (e) => {
  //   const { name, value } = e.target;

  //   setDatesData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };
  const handleFormChange = (e) => {
    const { name, value } = e.target;

    if (name === "date") {
      const formattedDate = moment(value, moment.ISO_8601, true).isValid()
        ? moment(value).format("ddd DD MMM YYYY")
        : "Invalid date"; // Handle invalid date

      setDatesData((prevData) => ({
        ...prevData,
        [name]: formattedDate,
      }));
    } else {
      setDatesData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleDoctorChange = (value) => {
    setDatesData((prevData) => ({
      ...prevData,
      doctorId: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentSlot) {
      console.error("No slot selected for editing");
      return;
    }

    const slotId = currentSlot.slotsId;
    try {
      await axios.put(`${API_BASE_URL}${EDIT_SLOTS}${slotId}`, datesData);
      // Reset form data after successful submission
      setDatesData({
        date: "",
        doctorId: "",
        fromTime: "",
        toTime: "",
        interval: "",
      });
      console.log();
      fetchSlotsById(data); // Fetch slots again to reflect changes
      handleBack(); // Go back to slots list view
    } catch (err) {
      console.error("Error updating slot:", err);
      if (err.response) {
        console.error("Server responded with status:", err.response.status);
        console.error("Response data:", err.response.data);
      } else if (err.request) {
        console.error("No response received:", err.request);
      } else {
        console.error("Error setting up request:", err.message);
      }
    }
  };
  const handleReset = () => {
    setDatesData({
      date: "",
      doctorId: "",
      fromTime: "",
      toTime: "",
      interval: "",
    });
  };
  const handleDelete = async (slotId) => {
    try {
      await axios.delete(`${API_BASE_URL}${DELETE_SLOTS}${slotId}`);
      fetchSlotsById(data); // Fetch slots again to reflect changes
    } catch (error) {
      console.error("Error deleting slot:", error);
    }
  };

  const columns = [
    { title: "Serial Number", dataIndex: "serialNumber", key: "serialNumber" },
    { title: "Doctor Name", dataIndex: "doctorName", key: "doctorName" },
    { title: "Date", dataIndex: "date", key: "date" },
    { title: "Start Time", dataIndex: "fromTime", key: "fromTime" },
    { title: "End Time", dataIndex: "toTime", key: "toTime" },
    { title: "Action", dataIndex: "action", key: "action" },
  ];

  const dynamicData = slots.map((dataItem, index) => ({
    key: dataItem.slotsId, // Ensure unique key
    serialNumber: <Typography variant="button">{index + 1}</Typography>,
    doctorName: <Typography variant="button">{dataItem.doctorName}</Typography>,
    date: <Typography variant="button">{dataItem.date}</Typography>,
    fromTime: <Typography variant="button">{dataItem.fromTime}</Typography>,
    toTime: <Typography variant="button">{dataItem.toTime}</Typography>,
    action: (
      <div>
        <Button
          size="small"
          style={{
            width: "1.5rem",
            height: "1.5rem",
            border: "1px solid #0899f9",
            color: "#0899f9",
          }}
          onClick={() => handleEdit(dataItem)}
        >
          <EditOutlined />
        </Button>
        <Button
          size="small"
          style={{
            width: "1.5rem",
            height: "1.5rem",
            border: "1px solid #941717",
            color: "#941717",
          }}
          onClick={() => handleDelete(dataItem.slotsId)}
        >
          <DeleteOutlined />
        </Button>
      </div>
    ),
  }));
  return (
    <>
      {!editSlots ? (
        <Table
          columns={columns}
          dataSource={dynamicData}
          rowKey="key"
          pagination={{ pageSize: 5 }} // Pagination with 5 rows per page
          style={{ fontSize: "12px" }} // Adjust row size
        />
      ) : (
        <div padding="20px">
          <div
            display="flex"
            flexDirection="row"
            style={{ marginBottom: "20px" }}
          >
            <Row style={{ gap: "8px" }}>
              <Col xl={11} lg={10} sm={24} md={12}>
                <div>
                  <Typography style={{ fontWeight: "bold" }}>Date</Typography>
                  <Input
                    name="formDate"
                    type={isDateInput ? "date" : "text"}
                    value={datesData.date}
                    onChange={handleFormChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    style={{
                      width: "100%",
                      height: "40px",
                    }}
                  />
                </div>
              </Col>
              <Col xl={11} lg={10} sm={24} md={12}>
                <div>
                  <Typography style={{ fontWeight: "bold" }}>
                    Duration [MM]
                  </Typography>
                  <Input
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "40px",
                    }}
                    required
                    name="intervalTime"
                    value={datesData.interval}
                    onChange={handleFormChange}
                    variant="outlined"
                  />
                </div>
              </Col>
            </Row>
          </div>
          <Row style={{ gap: "8px", marginTop: "1rem" }}>
            <Col xl={11} lg={10} sm={24} md={12}>
              <div>
                <Typography style={{ fontWeight: "bold" }}>
                  From Time
                </Typography>
                <Input
                  style={{
                    width: "100%",
                    height: "40px",
                  }}
                  required
                  name="fromTime"
                  placeholder="From Time"
                  value={datesData.fromTime}
                  onChange={handleFormChange} // Corrected
                  variant="outlined"
                />
              </div>
            </Col>

            <Col xl={11} lg={10} sm={24} md={12}>
              <div>
                <Typography style={{ fontWeight: "bold" }}>To Time</Typography>
                <Input
                  style={{
                    width: "100%",
                    height: "40px",
                  }}
                  required
                  name="toTime"
                  placeholder="To Time"
                  value={datesData.toTime}
                  onChange={handleFormChange} // Corrected
                  variant="outlined"
                />
              </div>
            </Col>
          </Row>
          <Row style={{ gap: "8px", marginTop: "1rem" }}>
            <Col xl={24} lg={24} sm={24} md={24}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  type="button"
                  onClick={handleReset}
                  style={{
                    color: "black",
                    border: "solid #1236fa",
                    width: "70px",
                    borderRadius: "12px",
                  }}
                >
                  Reset
                </Button>
                <Button
                  type="submit"
                  onClick={handleSubmit}
                  style={{
                    color: "white",
                    background: "#1236fa",
                    width: "70px",
                    borderRadius: "12px",
                  }}
                >
                  Submit
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};
export default EditSlots;
